import { useState, useEffect } from "react";
import { listarTiposPorCategoriaService } from "../../../services/tipoMensagemService";

export const useTiposMensagem = (categoriaId: number) => {
  const [tipos, setTipos] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTipos = async () => {
    if (!categoriaId) return;
    setIsLoading(true);
    const data = await listarTiposPorCategoriaService(categoriaId);

    console.log("data tipos", data);
    setTipos(data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTipos();
  }, [categoriaId]);

  return { tipos, isLoading, fetchTipos };
};
